import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getOriginContext, getCurrency, onCurrencyChange } from '@/utils/originHost';

import skCommon from './locales/sk/common.json';
import skEnergy from './locales/sk/energy.json';
import skWater from './locales/sk/water.json';

import csCommon from './locales/cs/common.json';
import csEnergy from './locales/cs/energy.json';
import csWater from './locales/cs/water.json';

/** Read language from URL ?lang= parameter, else from origin host. Defaults to 'sk'. */
function getLanguageFromUrl(): string {
  try {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    if (lang === 'cs') return 'cs';
    if (lang === 'sk') return 'sk';
  } catch {
    // SSR or malformed URL
  }
  try {
    if (getOriginContext().isCz) return 'cs';
  } catch {
    // ignore
  }
  return 'sk';
}

i18n.use(initReactI18next).init({
  lng: getLanguageFromUrl(),
  fallbackLng: 'sk',
  supportedLngs: ['sk', 'cs'],
  ns: ['common', 'energy', 'water'],
  defaultNS: 'common',
  resources: {
    sk: { common: skCommon, energy: skEnergy, water: skWater },
    cs: { common: csCommon, energy: csEnergy, water: csWater },
  },
  interpolation: {
    escapeValue: false, // React already escapes
    // Currency follows the API server, not the language.
    defaultVariables: { currency: getCurrency().symbol },
  },
  react: {
    useSuspense: false,
  },
});

// Keep `{{currency}}` in sync (mutated in place: i18next reads this object at interpolation time).
const syncCurrency = () => {
  const vars = i18n.options.interpolation?.defaultVariables as Record<string, string> | undefined;
  if (vars) vars.currency = getCurrency().symbol;
};
onCurrencyChange(syncCurrency);

// Set HTML lang attribute reactively
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
// Set initial
document.documentElement.lang = i18n.language;
syncCurrency();

export default i18n;
